import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import Select, { StylesConfig } from "react-select";

import { GET_VENDORS_FOR_REPORT } from "../../../../../Qurries";
import { CustomDropdownIndicator } from "../../../Settlement/Settlement";

interface VendorOption {
  label: string;
  value: string;
  id: string;
}

interface VendorSelectProps {
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  menuIsOpen?: boolean;
}

function VendorSelect({ setFilters, menuIsOpen }: VendorSelectProps) {
  const [vendors, setVendors] = useState<VendorOption[]>();

  const { data, loading } = useQuery(GET_VENDORS_FOR_REPORT, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (data?.getVendorsForMerchantReport) {
      const fetchedVendors = data.getVendorsForMerchantReport.map((vendor: any) => ({
        label: vendor.name,
        value: vendor.name,
        id: vendor.vendor_id,
      }));
      setVendors(fetchedVendors);
    }
  }, [data]);

  const customStyles: StylesConfig<VendorOption> = {
    control: (base) => ({
      ...base,
      backgroundColor: "#F6F8FA",
      border: "1px solid #1B163B",
      borderRadius: "6px",
      minHeight: "15px",
      margin: 0,
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px 0.5rem",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "200px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#1E1B59",
      fontSize: "12px",
    }),
  };

  return (
    <div className="w-full flex flex-col">
      <Select
        className="font-normal capitalize"
        closeMenuOnSelect={true}
        options={vendors}
        menuIsOpen={menuIsOpen}
        isLoading={loading}
        isMulti={false} 
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        onChange={(newValue, _actionMeta) => {
          const option = newValue as VendorOption | null;
          if (option) {
            setFilters((prevFilters: any) => ({
              ...prevFilters,
              vendor_id: option.id,
            }));
          }
        }}
        placeholder="Select Vendor"
        styles={customStyles}
      />
    </div>
  );
}

export default VendorSelect;
